import React, { PropsWithChildren, useContext, useMemo } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { rem } from 'polished'
import { PICKER_DATE_FORMAT } from 'constants/dateFormats'
import BodyText from 'components/Luxkit/Typography/BodyText'
import ArrowIcon from 'components/Luxkit/Icons/custom/RightHeadedArrowIcon'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import FlightSearchWidgetStateContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateContext'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { formatOccupantsShort } from 'lib/offer/occupancyUtils'

const DateInfo = styled.div`
  display: flex;
  align-items: center;

  > * + * {
    margin-left: ${rem(12)};
  }
`

interface Props {
  title: string;
  checkinDate?: moment.Moment;
  checkoutDate?: moment.Moment;
  travellerLabel?: string;
  textApply?: string;
  textCancel?: string;
}

function FlightSearchMenu(props: PropsWithChildren<Props>) {
  const {
    title,
    children,
    textApply = 'Apply',
    textCancel = 'Cancel',
  } = props

  const { resolve } = useModalElementContext()
  const { checkinDate, checkoutDate, occupants } = useContext(FlightSearchWidgetStateContext)
  const travellerLabel = useMemo(() => formatOccupantsShort(occupants), [occupants])

  return (
    <ModalBase mode="drawer">
      <form onSubmit={e => {
        e.preventDefault()
        resolve()
      }}>
        <ModalHeader title={title}/>
        <ModalBody>
          <ModalContent>
            {children}
          </ModalContent>
        </ModalBody>
        <ModalFooter
          primaryActionProps={{
            children: textApply,
            type: 'submit',
            fit: 'full-width',
            'data-testid': 'view-offers-filter-button',
          }}
          secondaryActionProps={{
            children: textCancel,
            fit: 'full-width',
          }}
        >
          {checkinDate && checkoutDate && (
            <DateInfo>
              <BodyText variant="medium" weight="semi-bold">{moment(checkinDate).format(PICKER_DATE_FORMAT)}</BodyText>
              <ArrowIcon />
              <BodyText variant="medium" weight="semi-bold">{moment(checkoutDate).format(PICKER_DATE_FORMAT)}</BodyText>
            </DateInfo>
          )}
          {travellerLabel && (
            <BodyText variant="medium" weight="semi-bold">{travellerLabel}</BodyText>
          )}
        </ModalFooter>
      </form>
    </ModalBase>
  )
}

export default FlightSearchMenu
